module.exports = __webpack_public_path__ + "img/business10.0b6bfb78.png";